import React from "react";
import { Field, reduxForm } from "redux-form";
import { Button, Col, Row } from "antd";
import { Link } from "react-router-dom";
import S from "string";
import { renderField } from "utils/forms";

const fields = ["email"];
const validate = values => {
  const errors = {};

  fields.forEach(field => {
    if (!values[field]) {
      errors[field] = `${S(field).humanize().s} required`;
    }
  });

  return errors;
};

let LoginForm = props => {
  const { handleSubmit } = props;
  return (
    <form onSubmit={handleSubmit}>
      <Row type="flex" justify="center" align="middle">
        <Col md={8} xs={20}>
          <Field
            label="Email"
            name="email"
            component={renderField}
            type="email"
          />
          <Field
            label="Password"
            name="password"
            component={renderField}
            type="password"
          />
        </Col>
      </Row>
      <Row type="flex" justify="center">
        <Col md={6} xs={20}>
          <Button
            style={{
              width: "100%"
            }}
            type="primary"
            htmlType="submit"
          >
            Login
          </Button>
        </Col>
      </Row>
      <Row type="flex" justify="center" className="auth-links">
        <p>
          Forgot password? <Link to="/forgot-password">Reset it</Link>
        </p>
      </Row>
    </form>
  );
};

export default reduxForm({
  form: "login",
  validate
})(LoginForm);



// WEBPACK FOOTER //
// ./src/components/auth/forms/login.js